import { createGetChannel, createPostChannel } from '../utils/apis/requestRX';
import { Fetch, ResponseData, ResponseList } from '../utils/apis/typeRX';

//获取手机验证码参数
export interface SmsCodeParams {
    captchaCode?: string;
    captchaUniqueId?: string;
    phoneNum: string | null;
    useType: string;
}

//获取手机验证码
export const getSmsCode: Fetch<SmsCodeParams, ResponseData<string>> = createPostChannel('/api/reexuan-blockchain-service/explorer/verification/smsCode');